import React from 'react';
import { Link } from 'react-router-dom';

const CaseStudyCard = ({ image, title, company, description, link = '/case-studies' }) => {
  return (
    <div className="overflow-hidden transition-all bg-white border rounded-lg shadow-sm hover:shadow-md border-gray-100">
      {image && (
        <img 
          src={image} 
          alt={title} 
          className="object-cover w-full h-48"
        />
      )}
      <div className="p-6">
        <span className="inline-block px-3 py-1 mb-2 text-xs font-medium text-primary bg-primary/10 rounded-full">{company}</span>
        <h3 className="mb-3 text-xl font-semibold">{title}</h3>
        <p className="mb-4 text-gray-600">{description}</p>
        <Link to={link} className="flex items-center font-medium text-primary hover:underline">
          Read case study
          <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default CaseStudyCard;
